import { AgGridReact } from 'ag-grid-react';
import React, {useState, useEffect} from 'react';
import { Box, CircularProgress, Typography } from "@material-ui/core";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import common from '../../services/commonService';
import { PlanesFilter } from './planesFilter';


export function RecordList(props: any) {

    // const [gridApi, setGridApi] = useState(null);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  
    const [value, setValue] = useState(0); // integer state

 
  
    const planeFormatter = (params:any) => {
      const state = params.data.state;
      const planes = state?.planes || 0;
      return planes ? planes.toString() : '';
    }

    const indexFormatter = (params:any) => {
      const state = params.data.state;
      if (state?.index !== undefined)
        return (state.index).toString();
      return '';
    }

  
    const columnDefs = [
      {headerName: '', 
        field: 'state',
        width: 20, 
        headerComponentParams: {
          template: '<div style="display: table-cell;vertical-align:middle; width:12px; min-width:12px; max-width:12px; height:12px;border-left:6px solid gray;border-right:6px solid gray;border-bottom:6px solid transparent" ></div>'
        },
        equals: (s1:any, s2:any) => { 
          return false;},
        cellRenderer: (data:any) => {
          let color = data?.value?.bookmark ? 'skyBlue' : 'transparent';
          if (data?.value?.lastSaved)
          color = 'mediumBlue';
            
          return '<div style="background-color:' + color + ';display: table-cell;vertical-align:middle; width:12px; min-width:12px; max-width:12px; height:12px" ></div>';
      }},
      {headerName: 'Index', width: 80,
        field: 'state', valueFormatter: indexFormatter
       },
     {headerName: 'State', width: 150,
      field: 'state', 
      cellRenderer: (data:any) => { return getStateRenderer(data)}
     },

    ];

    const getBox = (clr:string) => {
      return `<div style="background-color:${clr};display: table-cell;vertical-align:middle; width:12px; min-width:12px; max-width:12px; height:12px;" ></div>`;
    }

    const getStateRenderer = (data:any) => {
      try {
        const gap = '<Box display="flex" width="0px"></Box>';
        const problematic = data?.value?.problematic;
        const problematicColor = problematic ? 'red':'transparent';
        const planes = data?.value?.planes || 0;
        const planesColor = planes > 0 ? 'lawnGreen' : 'transparent';
        const plates = data?.value?.plates || 0;
        const platesColor = plates > 0 ? 'cyan' : 'transparent';
        const wheels = data?.value?.wheels || 0;
        const wheelsColor = wheels > 0 ? 'magenta' : 'transparent';
          const boxes = [];
        boxes.push(getBox(problematicColor));
        boxes.push(gap);
        boxes.push(getBox(planesColor));
        boxes.push(gap);
        boxes.push(getBox(platesColor));
        boxes.push(gap);
        boxes.push(getBox(wheelsColor));
        const boxed = boxes.join(' ');
        const combined =  `<Box display="table-cell"> ${boxed} </Box>`;
        return combined;
      } catch (ex) {
        console.error('failed to get cell renderer:', ex);
        return '';
      }
    }

    const handleCellFocused = (e: any) => {
      try {
        const api = common.planes.gridApi;
        api.forEachNode((node:any)=> node.setSelected(node.rowIndex === e.rowIndex));
      } catch (ex) {
        console.error('failed to handle cell focus:', ex);
      }
    }
  

  
    const handleSelection = (e: any) => {
      try {
        // disable selection while loading plate
   
  
        const selectedRows = e.api.getSelectedRows();
        if (selectedRows.length === 0)
          return;
          
        const selectedRow = selectedRows[0];
        // WTT-363
        common.planes.selectedRow = selectedRow;
        common.notify("PlanesRecordSelected", selectedRow.id);
      } catch (ex) {
        console.error('failed on handle selection');
      }
    }

    const gotoNextRecord = () => {
      try {
        const api = common.planes.gridApi;
        if (api == null) return;
  
        const selectedRow = common.planes.selectedRow;
        let currentNode:any = null;
        api.forEachNode((node:any) => {if (node.data === selectedRow) currentNode = node });
        if (!currentNode) throw(new Error('failed to find current node'));
        api.forEachNode((node:any)=> node.rowIndex === currentNode.rowIndex + 1 ? node.setSelected(true) : node.setSelected(false));
      } catch (ex) {
        console.error('failed to gotoNext:', ex);
      }
    }
  
    /**
     * Select the first record
     */
    const selectFirstRecord = () => {
      try {
        setTimeout(() => {
          const api = common.planes.gridApi;
          if (api) 
            api.forEachNode((node:any)=> node.rowIndex == 0  ? node.setSelected(true) : node.setSelected(false))
        }, 100);
      } catch (ex) {
        console.error('failed to select first row:', ex);
      }
    }
  
    function onGridReady(params:any) {
      // setGridApi(params.api);
      common.planes.gridApi = params.api;
  }
  

    const handleCallbacks = (key: string, value: any) => {
      try {
        switch(key) {

          case 'PlanesLoadStateChanged':
            setValue(value => value + 1);
            break;

          case 'PlanesRecordsChanged':
            common.planes.gridApi.refreshRows();
            setValue(value => value + 1);
            break;

          case 'PlanesSelectFirstRecord':
            selectFirstRecord();
            break;

          case 'PlanesSelectNextRecord':
            gotoNextRecord();
            break;

          case 'PlanesSelectRecord':
            selectRecord(value);
            break;

          case 'PlanesRefreshRecords':
            refreshCells();
            break;
    
        }
  
      } catch (ex) {
        console.error('failed to handle callbacks:', ex);
      }
  
    }

    const refreshCells = () => {
      try {
        const api = common.planes.gridApi;
        api.refreshCells();
      } catch (ex) {

      }
    }

      /**
   * double click cell to toggle bookmark
   * @param e 
   */
  const handleCellDoubleClicked = (e: any) => {
    try {
      const api = common.planes.gridApi;
      const state = common.planes.state;
      e.data.state.bookmark = !e.data.state.bookmark;
      common.planes.gridApi.refreshCells();
      const records = common.planes.records;
      state.bookmarks = records.filter(r => r.state.bookmark).map(r => `${r.sequence}-${r.image}`);
      common.notify("PlanesSaveState");
    } catch (ex) {
      console.error('failed to handle cell focus:', ex);
    }
  }

    /**
     * select record by imageId
     * @param id 
     */
    const selectRecord = (id: any) => {
      try {
        const api = common.planes.gridApi;
        api.forEachNode((node:any)=> node.data.image === id ? node.setSelected(true) : node.setSelected(false));
        api.forEachNode((node:any)=> {if (node.data.image === id) api.ensureNodeVisible(node, 'middle')});
        
        common.notify("LoadPlate", id);
      } catch (ex) {
        console.error('failed to handle plate selection')
      }
    }
  
  
    useEffect(() => {
      const subscription = common.notifier$.subscribe(msg => {
        handleCallbacks(msg.name as string, msg.data);
      });
      return (() => {
        subscription.unsubscribe();
      });
     
    });
  
  
  const records = common.planes.records || [];
  const loading = common.planes.loadingDataset;
  
    return (
      <Box display="flex" flex="1" flexDirection="column" >
      
               <PlanesFilter/>
                <div
                  className="ag-theme-balham"
                  style={{ height: '100%', width: '300px' }}
              >
                  <AgGridReact
                      rowHeight={32}
                      rowSelection={'single'}
                      onGridReady={onGridReady}
                      columnDefs={columnDefs}
                      onSelectionChanged={ (e:any) => handleSelection(e)}
                      onCellFocused = {(e:any) => handleCellFocused(e)}
                      onCellDoubleClicked = {(e:any) => handleCellDoubleClicked(e)}
                      rowData={records}>
                </AgGridReact>
  
              </div>
        </Box>
    );
  
  }